<template>
  <div v-loading="loading" class="rj-page-card">
    <div class="rj-page-card__title">
      合同基本信息
    </div>
    <div class="rj-page-card__content">
      <div class="baseInfoForm">
        <div class="rj-row">
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                汇款编号：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.telegraphicTransferNo }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                合同编号：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.cotractNum }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                客户名称：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.orderUnit }}
              </div>
            </div>
          </div>

          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                实际付款人名称：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.drawee }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                汇款账号：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.paymentAccount||'无' }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                汇款金额：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.remittanceAmount }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                实际付款人国家：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.sourceCountries }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                汇款日期：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.remittanceTime }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                汇款方式：
              </div>
              <div class="rj-baseinfo__item">
                {{ remittanceWayOptions[form.remittanceWay] }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                交易币种：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.currencyName }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                汇入账号：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.importAccount }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                汇入公司：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.importCompany }}
              </div>
            </div>
          </div>

          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                汇款用途：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.strRemittanceScenario }}
              </div>
            </div>
          </div>
          <!-- <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                汇款类型：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.strRemittanceType }}
              </div>
            </div>
          </div> -->
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                收款单号*：
              </div>
              <div class="rj-baseinfo__item">
                <span v-if="isshows === 0">
                  {{ form.telegraphicTransferNum }}
                </span>
                <span v-if="isshows === 1">
                  <el-input v-model="form.telegraphicTransferNum" placeholder="请输入资管收款单号" @blur="tijiaos()" />
                </span>
              </div>
            </div>
          </div>
          <div class="rj-col-1">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                备注：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.remark }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <el-table :data="form.telegraphicContractRelationList" border style="width: 100%">
        <el-table-column prop="cotractNum" label="合同编号" align="left" />
        <el-table-column prop="splitAmount" label="拆分金额" align="left" />
        <el-table-column prop="remittanceType" label="付款类型" align="left">
          <template v-slot="{row}">
            <span v-if="row.remittanceType === 0">现销付款/赊销预付款</span>
            <span v-if="row.remittanceType === 1">赊销回款</span>
          </template>
        </el-table-column>
        <el-table-column prop="ledgerNumber" label="台账 *" align="left" />
      </el-table>
    </div>
  </div>
</template>
<script type="es6">
import { mapState } from 'vuex';
import { verifyreceiptnumber } from '@/API/international.js';

export default {
  data () {
    return {
      loading: false,
      isshows: true
    };
  },
  model: {
    prop: 'form',
    event: 'change'
  },
  props: {
    form: {
      type: Object,
      default: () => { return {}; }
    }
  },
  computed: {
    ...mapState({
      remittanceScenarioOptions: state => state.enumeration.remittanceScenarioOptions,
      remittanceWayOptions: state => state.enumeration.remittanceWay,
      remittanceType: state => state.enumeration.remittanceType
    })
  },
  methods: {
    tijiaos () {
      this.form.telegraphicTransferNum = (this.form.telegraphicTransferNum || '').trim();
      let params = {
        receiptNumber: this.form.telegraphicTransferNum,
        type: 0
      };
      verifyreceiptnumber(params).then((res) => {
        const json = res.data;
        if (json.status === '200') {
          this.form.actualRemittanceAmount = json.data.actualRemittanceAmount;
          this.form.numberAccount = (this.form.remittanceAmount - this.form.actualRemittanceAmount).toFixed(2);
          this.$emit('telegraphicTransferNumBlur', json.data.currency);
          if (json.data.isReceipt === true) {
            this.$message.success('该收款单号已生成收款单');
          }
        } else {
          this.form.actualRemittanceAmount = '';
          this.form.numberAccount = '';
        }
      }).catch((err) => {
        console.log(err);
        this.form.actualRemittanceAmount = '';
        this.form.numberAccount = '';
      });
    }
  },
  mounted () {
    const unWatch = this.$watch('form.telegraphicTransferNum', (newVal, oldVal) => {
      // 只执行一次的逻辑
      if (newVal === null || newVal === '') {
        this.isshows = 1;
      } else {
        this.isshows = 0;
      };
      unWatch(); // 取消监听
    });
    this.$store.dispatch('enumeration/initremittance');
  }
};
</script>
<style lang="scss">
  .baseInfoForm {
    .el-form-item--mini.el-form-item {
      margin-bottom: 0;
    }
  }
</style>
<style lang="scss">
  .baseInfoForm{
    .el-form-item__error{
      position: relative;
    }
  }
  .required{
    color: red;
    margin-left: 3px;
  }
</style>
